/* eslint-disable class-methods-use-this */
import Vue from 'vue';
import login from '@tencent/vft-common/login';
import env from '@tencent/vft-common/env';
import LoginPlugin from '@tencent/vft-vue-plugins/src/login';
import atom from '@tencent/vft-atom';
import { loadScript } from '@tencent/vft-utils';
import { TypeLoginService } from './index.interface';

export class LoginService implements TypeLoginService {
  isInited = false

  isLogin = false

  async init(): Promise<void> {
    if (!env.isApp && !(window as any).$.ajax) {
      // login.init 刷新登录态，发送请求依赖于zepto库
      await loadScript(
        '//vm.gtimg.cn/tencentvideo_v1/script/film/weixin/v2/lib/zepto.1.2.min.js?max_age=31104000',
      );
    }
    await new Promise((resolve) => {
      login.init(resolve);
    });
    this.isLogin = login.isLogin();
    this.isInited = true;
  }

  openLogin(args: { type?: string } = {}): void {
    // if (env.isApp) {
    //   atom.openLogin(args?.type);
    // } else {
    if (!Vue.prototype.$openLogin) {
      Vue.use(LoginPlugin);
    }
    Vue.prototype.$openLogin(args);
    // }
  }

  onLogin(callback: Function): void {
    if (env.isApp) {
      atom.on('onActionLoginFinish', () => {
        setTimeout(callback, 0);
      });
    }
  }

  onLogout(callback: Function): void {
    if (env.isApp) {
      atom.on('onActionLogoutFinish', () => {
        setTimeout(callback, 0);
      });
    }
  }

  onLoginStateChange(callback: Function): void {
    this.onLogin(callback);
    this.onLogout(callback);
  }
}

const loginService = Vue.observable(new LoginService());
export default loginService;
